import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import LoginIcon from "../../../../media/images/icons/login-newsvg";
import PlusMiniSvg from "../../../../media/images/icons/plus-mini";

export default function ForgetPassLink() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        marginTop: "32px",
        marginBottom: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <Typography>{"حساب کاربری ندارید؟"}</Typography>
      <Link
        to={"/signup"}
        style={{
          padding: 5,
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <PlusMiniSvg size={18} color={theme.palette.primary.main} />
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 600,
          }}
        >
          ثبت نام جدید
        </Typography>
      </Link>
    </Box>
  );
}
